import React from 'react';
import Styled from 'styled';
import classnames from 'classnames';
import { Mutation } from '@apollo/client/react/components';
import { FormattedMessage } from 'react-intl';

import ImageView from 'lib/images/image-view';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import bookmark from 'four-nets/icons/svg/icon_bookmark.svg';

import mutation, {
    CreateCollectionImageMutation,
    CreateCollectionImageMutationVariables,
} from '../../mutations/create-collection-image.graphql';
import { CollectionRowFragment } from './collection-row.graphql';
import defaultStyles from './collection-row.scss';

export interface Props extends CollectionRowFragment {
    styles: typeof defaultStyles;
    imageId: string;
    onClose: () => void;
}

class CollectionRow extends React.PureComponent<Props> {
    render() {
        const { styles, imageId, onClose, ...collection } = this.props;

        let tag = collection.hasImage ? 'div' : 'button';

        return (
            <Mutation<CreateCollectionImageMutation, CreateCollectionImageMutationVariables> mutation={mutation}>
                {create => {
                    const onClick = () => {
                        create({
                            variables: {
                                input: {
                                    imageId,
                                    collectionId: collection.id,
                                },
                            },
                        }).then(onClose);
                    };

                    return React.createElement(
                        tag,
                        { className: styles.collectionRow, onClick: collection.hasImage ? undefined : onClick },
                        <React.Fragment>
                            <div className={styles.info}>
                                <div className={styles.avatar}>
                                    <ImageView
                                        aspectRatio={1}
                                        aspectFill={true}
                                        sizes={{ xs: 20 }}
                                        src={
                                            collection.images &&
                                            collection.images.edges &&
                                            collection.images.edges.length &&
                                            collection.images.edges[0] &&
                                            collection.images.edges[0]!.node &&
                                            collection.images.edges[0]!.node.image.photoFile.src
                                        }
                                        srcSet={
                                            collection.images &&
                                            collection.images.edges &&
                                            collection.images.edges.length &&
                                            collection.images.edges[0] &&
                                            collection.images.edges[0]!.node &&
                                            collection.images.edges[0]!.node.image.photoFile.srcset
                                        }
                                        alt='collection-avatar'
                                    />
                                </div>
                                <div className={styles.title}>{collection.title}</div>
                            </div>
                            <div className={classnames(styles.button, { [styles.saved]: collection.hasImage })}>
                                <SVGIcon style={{ image: styles.icon }} src={bookmark} />
                                {collection.hasImage ? (
                                    <FormattedMessage id='SAVED' />
                                ) : (
                                    <FormattedMessage id='SAVE' values={{ gender: 'v' }} />
                                )}
                            </div>
                        </React.Fragment>
                    );
                }}
            </Mutation>
        );
    }
}

export default Styled(defaultStyles)(CollectionRow);
